import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useProjectCustomFields } from 'utils/project-fields/use-project-fields';
import { getDynamicConditionFields } from '../utils';
import { useActiveTemplateId } from './use-active-project-template';
const getProjectDynamicTemplateConditions = ()=>createSelector((state)=>state.templates.project.data, (_, { templateId })=>({
            templateId
        }), (data, { templateId })=>data[templateId].dynamicConditions);
export const useProjectDynamicTemplateConditions = ()=>{
    const templateId = useActiveTemplateId();
    const projectDynamicConditions = useMemo(getProjectDynamicTemplateConditions, []);
    return useSelector((state)=>projectDynamicConditions(state, {
            templateId
        }));
};
export const useDynamicConditionFields = ()=>{
    const { data: projectCustomFields } = useProjectCustomFields();
    return useMemo(()=>getDynamicConditionFields(projectCustomFields), [
        projectCustomFields
    ]);
};
